<template>
  <div id="app">
    <BlockUI :blocked="loadingCount > 0" :full-screen="true" />
    <Toast></Toast>
    <ConfirmDialog></ConfirmDialog>
    <Nav></Nav>
    <router-view />
    <AppFooter v-if="store.token"></AppFooter>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useTitle, useSessionStorage } from "@vueuse/core";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
import { usePlugin } from "./plugins";
import Toast from "primevue/toast";
import ConfirmDialog from "primevue/confirmdialog";
import Nav from "@/components/Navigation.vue";
import AppFooter from "@/components/Footer.vue";

export default defineComponent({
  name: "App",
  components: { Toast, ConfirmDialog, Nav, AppFooter },
  setup() {
    const loadingCount = useSessionStorage("loadingCount", 0);
    const { setupPlugin } = usePlugin();
    const toast = useToast();
    const confirm = useConfirm();
    setupPlugin(toast, confirm, loadingCount);

    const { store } = usePlugin();

    onMounted(() => {
      const title = useTitle();
      title.value = "POD Admin";
    });

    return { store, loadingCount };
  },
});
</script>
